export const enrollModal = {
  title: 'Enroll another participant',
  description: 'Have you enrolled yourself and all other minor children or dependents?',
  buttonsText: {
    enrollNow: 'Enroll Now', 
    allAreEnrolled: 'All are enrolled', 
    enrollLater: 'Enroll Later'
  }
};